import { useFlag } from '../FeatureFlag/FeatureFlag'

export const useNestedModifiers = () => {
  const nestedModifiersEnabled = useFlag('oo-v3-nested-modifiers', false)
  const nestingLevel = nestedModifiersEnabled ? 10 : 1
  return { nestingLevel }
}
